<div class="wrapper">
  <app-organization-share-buyers-list
    type="SMS"
    [showCloseButton]="true"
    (handleClose)="handleClose.emit()"
  ></app-organization-share-buyers-list>
</div>
